import LineNumber from './LineNumber';
import { LineNumberProps, LineNumberValueProps } from './types';

export type { LineNumberProps, LineNumberValueProps };
export default LineNumber;
